export default __webpack_public_path__ + "static/media/scan.a8badcc3.svg";